import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Picker } from '@react-native-picker/picker';
import { getLanguages } from 'services/languageService';
import Language from 'types/models/Language';
import AsyncStorage from '@react-native-async-storage/async-storage';
import useMediumScreen from 'hooks/useMediumScreen';
import Storage from 'constants/Storage';

export default (): JSX.Element => {
  const { i18n, t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(i18n.language);
  const [languages, setLanguages] = useState<Language[] | null>(null);

  const mediumScreen = useMediumScreen();

  const getAllLanguages = async () => {
    setLanguages(await getLanguages());
  };

  useEffect(() => {
    getAllLanguages();
    i18n.changeLanguage(selectedLanguage);
  }, []);

  const handleLanguageChange = async (language: string) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);

    try {
      await AsyncStorage.setItem(Storage.language, language);
    } catch (error) {
      console.error('Error al guardar el idioma:', error);
    }
  };

  React.useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = await AsyncStorage.getItem(Storage.language);
        if (storedLanguage) {
          setSelectedLanguage(storedLanguage);
        }
      } catch (error) {
        console.error('Error al obtener el idioma:', error);
      }
    };

    loadLanguage();
  }, []);

  if (!languages?.length) return <></>;

  return (
    <View style={mediumScreen ? styles.container : styles.containerSmall}>
      <Text style={{ fontWeight: '500', fontSize: 17, lineHeight: 20, letterSpacing: 0.25, textAlign: 'left' }}>
        {t('language')}
      </Text>
      <Picker selectedValue={selectedLanguage} onValueChange={handleLanguageChange} style={styles.picker}>
        {languages.map(({ code, description, id }) => (
          <Picker.Item style={styles.pickerItem} key={id} label={description} value={code} />
        ))}
      </Picker>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',

    alignItems: 'center',
    width: 140,
    padding: 15,
  },

  containerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 140,
    padding: 15,
  },

  picker: {
    width: 200,
    height: 40,
    borderWidth: 1,
    borderRadius: 5,
    backgroundColor: 'rgb(38, 170, 241)',
    color: '#ffff',
    fontWeight: 'bold',
    padding: 10,
  },
  pickerItem: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: 'rgb(38, 170, 241)',
    paddingVertical: 10,
    paddingHorizontal: 15,
  },
});
